import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f71e088")

_pushScopeId("data-v-3f71e088")
const _hoisted_1 = {
  key: 0,
  class: "preloader-container"
}
const _hoisted_2 = {
  key: 1,
  class: "job-container"
}
const _hoisted_3 = { class: "display-flex" }
const _hoisted_4 = {
  class: "block-title no-margin",
  style: {"white-space":"nowrap"}
}
const _hoisted_5 = { class: "block-footer no-margin no-padding" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Finalize")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Submit Purchase Request")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Submit for Review")
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "item-content item-input item-input-outline" }
const _hoisted_14 = { class: "item-inner" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "item-title item-label" }, "Builder ID", -1)
const _hoisted_16 = { class: "item-input-wrap" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "card" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("DETAILS")
const _hoisted_20 = {
  id: "program-form",
  ref: "programForm"
}
const _hoisted_21 = { class: "item-content item-input item-input-outline" }
const _hoisted_22 = { class: "item-inner" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "item-title item-label" }, "Builder ID", -1)
const _hoisted_24 = { class: "item-input-wrap" }
const _hoisted_25 = /*#__PURE__*/_createVNode("h3", null, "Loading", -1)
const _hoisted_26 = {
  key: 1,
  id: "image-preview"
}
const _hoisted_27 = { for: "image-input" }
const _hoisted_28 = {
  key: 1,
  class: "upload"
}
const _hoisted_29 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_30 = {
  key: 1,
  class: "subtitle"
}
const _hoisted_31 = {
  key: 2,
  class: "btn"
}
const _hoisted_32 = {
  key: 0,
  style: {"flex":"1"}
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" PROGRAM DETAILS ")
const _hoisted_34 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { class: "label-cell" }, "Zone"),
    /*#__PURE__*/_createVNode("th", { class: "numeric-cell" }, "Ports"),
    /*#__PURE__*/_createVNode("th", { class: "numeric-cell" }, "Cycles"),
    /*#__PURE__*/_createVNode("th", { class: "numeric-cell" }, "Duration"),
    /*#__PURE__*/_createVNode("th", { class: "numeric-cell" }, "Runtime")
  ])
], -1)
const _hoisted_35 = {
  key: 0,
  class: "label-cell"
}
const _hoisted_36 = {
  key: 1,
  class: "label-cell"
}
const _hoisted_37 = { class: "numeric-cell" }
const _hoisted_38 = { class: "numeric-cell" }
const _hoisted_39 = { class: "numeric-cell" }
const _hoisted_40 = { class: "numeric-cell" }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" FILES ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("BILL OF MATERIALS")
const _hoisted_44 = { for: "bom-input" }
const _hoisted_45 = {
  key: 0,
  class: "info-box-pool360"
}
const _hoisted_46 = { style: {"flex-grow":"1"} }
const _hoisted_47 = /*#__PURE__*/_createVNode("h4", { style: {"margin-top":"0","margin-bottom":"5px","font-weight":"600"} }, "Streamline Your Order!", -1)
const _hoisted_48 = { style: {"margin-bottom":"0","line-height":"1.5","font-size":"15px","margin-top":"0"} }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Please take the Bill of Materials for this job to your local SCP or Superior Pool Products branch to purchase the materials. ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Please contact UAG to place your order. Please instruct UAG to include Job Name on the PO. ")
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Please contact CARECRAFT to place your order. Please instruct CARECRAFT to include Job Name on the PO. ")
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "fab-spacer mobile-only" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_preloader = _resolveComponent("f7-preloader")
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_f7_button = _resolveComponent("f7-button")
  const _component_f7_list_item = _resolveComponent("f7-list-item")
  const _component_f7_list = _resolveComponent("f7-list")
  const _component_f7_popover = _resolveComponent("f7-popover")
  const _component_f7_navbar = _resolveComponent("f7-navbar")
  const _component_f7_list_input = _resolveComponent("f7-list-input")
  const _component_engineering_form = _resolveComponent("engineering-form")
  const _component_f7_accordion_content = _resolveComponent("f7-accordion-content")
  const _component_f7_card = _resolveComponent("f7-card")
  const _component_f7_block_title = _resolveComponent("f7-block-title")
  const _component_f7_col = _resolveComponent("f7-col")
  const _component_f7_icon = _resolveComponent("f7-icon")
  const _component_f7_skeleton_block = _resolveComponent("f7-skeleton-block")
  const _component_f7_row = _resolveComponent("f7-row")
  const _component_import_program = _resolveComponent("import-program")
  const _component_file_upload = _resolveComponent("file-upload")
  const _component_bill_of_materials = _resolveComponent("bill-of-materials")
  const _component_f7_fab_button = _resolveComponent("f7-fab-button")
  const _component_f7_fab_buttons = _resolveComponent("f7-fab-buttons")
  const _component_f7_fab = _resolveComponent("f7-fab")
  const _component_f7_page = _resolveComponent("f7-page")

  return (_openBlock(), _createBlock(_component_f7_page, { name: "job" }, {
    default: _withId(() => [
      (_ctx.fetching)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_f7_preloader)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode(_component_f7_navbar, null, {
              left: _withId(() => [
                _createVNode("div", _hoisted_3, [
                  _createVNode(_component_f7_link, {
                    class: "mobile-only",
                    style: {"margin-right":"1rem"},
                    "icon-only": "",
                    "icon-f7": "chevron_left",
                    href: "/jobs"
                  }),
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_4, _toDisplayString(_ctx.pageState.job.name === "" ? "Unnamed Job" : _ctx.pageState.job.name), 1),
                    (!_ctx.newJob)
                      ? (_openBlock(), _createBlock(_component_f7_link, {
                          key: 0,
                          onClick: _ctx.copyID,
                          tooltip: "Copy ID",
                          style: {"line-height":"inherit","white-space":"nowrap"}
                        }, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_5, _toDisplayString("ID: " + _ctx.pageState.job.ID), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              right: _withId(() => [
                (!_ctx.newJob)
                  ? (_openBlock(), _createBlock(_component_f7_button, {
                      key: 0,
                      "popover-open": ".popover-menu",
                      "icon-f7": "ellipsis"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.canEdit || _ctx.pageState.job.state == 'finalized')
                  ? (_openBlock(), _createBlock(_component_f7_button, {
                      key: 1,
                      class: "desktop-only",
                      onClick: _ctx.save,
                      outline: ""
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.saveButtonText), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.pageState.job.state == 'staging')
                  ? (_openBlock(), _createBlock(_component_f7_button, {
                      key: 2,
                      class: "desktop-only",
                      onClick: _ctx.finalize,
                      fill: ""
                    }, {
                      default: _withId(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.pageState.job.state == 'finalized')
                  ? (_openBlock(), _createBlock(_component_f7_button, {
                      key: 3,
                      class: "desktop-only",
                      onClick: _ctx.purchase,
                      fill: "",
                      color: "green"
                    }, {
                      default: _withId(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.pageState.job.state == 'draft')
                  ? (_openBlock(), _createBlock(_component_f7_button, {
                      key: 4,
                      class: "desktop-only",
                      onClick: _ctx.submit,
                      fill: ""
                    }, {
                      default: _withId(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_f7_popover, { class: "popover-menu" }, {
                  default: _withId(() => [
                    _createVNode(_component_f7_list, null, {
                      default: _withId(() => [
                        (_ctx.pageState.job.state != 'draft')
                          ? (_openBlock(), _createBlock(_component_f7_list_item, {
                              key: 0,
                              link: "#",
                              onClick: _ctx.printBOM,
                              "popover-close": "",
                              title: "Print BOM"
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.pageState.job.state != 'draft')
                          ? (_openBlock(), _createBlock(_component_f7_list_item, {
                              key: 1,
                              link: "#",
                              onClick: _ctx.printEngineeringForm,
                              "popover-close": "",
                              title: "Print Engineering Form"
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.pageState.job.state != 'draft' && _ctx.appState.admin)
                          ? (_openBlock(), _createBlock(_component_f7_list_item, {
                              key: 2,
                              link: "#",
                              onClick: _ctx.printProgramDetails,
                              "popover-close": "",
                              title: "Print Program Details"
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.canEdit && !_ctx.newJob)
                          ? (_openBlock(), _createBlock(_component_f7_list_item, {
                              key: 3,
                              link: "#",
                              "popover-close": "",
                              title: "Delete Job",
                              onClick: _ctx.deleteJob
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode("div", _hoisted_9, [
              (_ctx.pageState.job.state == 'draft')
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_f7_list, null, {
                        default: _withId(() => [
                          (_ctx.appState.admin)
                            ? (_openBlock(), _createBlock("li", _hoisted_12, [
                                _createVNode("div", _hoisted_13, [
                                  _createVNode("div", _hoisted_14, [
                                    _hoisted_15,
                                    _createVNode("div", _hoisted_16, [
                                      _createVNode("input", {
                                        id: "builder-id",
                                        type: "text",
                                        placeholder: "Enter builder ID",
                                        required: "",
                                        validate: "",
                                        value: _ctx.pageState.job.builderID
                                      }, null, 8, ["value"])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_f7_list_input, {
                            outline: "",
                            label: "Project Name",
                            type: "text",
                            placeholder: "Name",
                            value: _ctx.pageState.job.name,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pageState.job.name = $event)),
                            required: "",
                            validate: ""
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_engineering_form, {
                        job: _ctx.pageState.job,
                        ref: "engineeringForm"
                      }, null, 8, ["job"])
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_17, [
                    _createVNode(_component_f7_card, { class: "no-margin-horizontal no-margin-bottom" }, {
                      default: _withId(() => [
                        _createVNode(_component_f7_list, { "accordion-list": "" }, {
                          default: _withId(() => [
                            _createVNode(_component_f7_list_item, {
                              "accordion-item": "",
                              title: "Engineering form"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_f7_accordion_content, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_engineering_form, {
                                      job: _ctx.pageState.job,
                                      ref: "engineeringForm",
                                      readonly: !_ctx.appState.admin
                                    }, null, 8, ["job", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_f7_row, { class: "align-items-stretch" }, {
                      default: _withId(() => [
                        _createVNode(_component_f7_col, null, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_18, [
                              _createVNode(_component_f7_block_title, { class: "no-margin" }, {
                                default: _withId(() => [
                                  _hoisted_19
                                ]),
                                _: 1
                              }),
                              _createVNode("form", _hoisted_20, [
                                _createVNode(_component_f7_list, { "no-hairlines": "" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_f7_list_input, {
                                      outline: "",
                                      label: "Project Name",
                                      type: "text",
                                      placeholder: "Name",
                                      value: _ctx.pageState.job.name,
                                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.pageState.job.name = $event)),
                                      required: "",
                                      validate: "",
                                      readonly: !_ctx.appState.admin && _ctx.pageState.job.state == 'purchased'
                        
                                    }, null, 8, ["value", "readonly"]),
                                    _createVNode(_component_f7_list_input, {
                                      outline: "",
                                      label: "Job ID",
                                      type: "text",
                                      value: _ctx.pageState.job.ID,
                                      readonly: ""
                                    }, {
                                      media: _withId(() => [
                                        (_ctx.qrImage && _ctx.qrImage != '')
                                          ? (_openBlock(), _createBlock(_component_f7_link, {
                                              key: 0,
                                              class: "qr-code",
                                              "popover-open": ".popover-qr"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode("img", {
                                                  width: "45",
                                                  alt: "QR CODE",
                                                  src: _ctx.qrImage
                                                }, null, 8, ["src"])
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_f7_popover, { class: "popover-qr" }, {
                                          default: _withId(() => [
                                            _createVNode("img", {
                                              class: "qr-image-large",
                                              alt: "QR CODE",
                                              src: _ctx.qrImage ?? undefined
                                            }, null, 8, ["src"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["value"]),
                                    _createVNode("li", _hoisted_21, [
                                      _createVNode("div", _hoisted_22, [
                                        _hoisted_23,
                                        _createVNode("div", _hoisted_24, [
                                          _withDirectives(_createVNode("input", {
                                            id: "bulider-id-input",
                                            outline: "",
                                            label: "Builder ID",
                                            type: "text",
                                            placeholder: "Builder ID",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pageState.job.builderID = $event)),
                                            required: "",
                                            validate: "",
                                            readonly: !_ctx.appState.admin
                                          }, null, 8, ["readonly"]), [
                                            [_vModelText, _ctx.pageState.job.builderID]
                                          ])
                                        ])
                                      ])
                                    ]),
                                    (_ctx.pageState.job.submissionDate)
                                      ? (_openBlock(), _createBlock(_component_f7_list_input, {
                                          key: 0,
                                          readonly: "",
                                          outline: "",
                                          label: "Submission date",
                                          value: _ctx.pageState.job.submissionDate.toDate().toDateString()
                      
                                        }, null, 8, ["value"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ], 512)
                            ])
                          ]),
                          _: 1
                        }),
                        (!_ctx.newJob)
                          ? (_openBlock(), _createBlock(_component_f7_col, {
                              key: 0,
                              style: {"display":"flex","align-items":"center"}
                            }, {
                              default: _withId(() => [
                                (_ctx.fetching)
                                  ? (_openBlock(), _createBlock(_component_f7_skeleton_block, {
                                      key: 0,
                                      class: "upload skeleton-effect-fade",
                                      style: {"width":"400px","height":"400px","margin":"0 auto","background-color":"white"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_f7_icon, {
                                          f7: "photo",
                                          size: "48"
                                        }),
                                        _hoisted_25
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock("form", _hoisted_26, [
                                      (_ctx.canEdit)
                                        ? (_openBlock(), _createBlock("input", {
                                            key: 0,
                                            type: "file",
                                            accept: "image/*",
                                            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.imageFileChange($event))),
                                            id: "image-input"
                                          }, null, 32))
                                        : _createCommentVNode("", true),
                                      _createVNode("label", _hoisted_27, [
                                        (_ctx.currentImage && _ctx.currentImage != '')
                                          ? (_openBlock(), _createBlock("img", {
                                              key: 0,
                                              alt: "Image Preview",
                                              src: _ctx.currentImage
                                            }, null, 8, ["src"]))
                                          : (_openBlock(), _createBlock("div", _hoisted_28, [
                                              _createVNode(_component_f7_icon, {
                                                f7: "photo",
                                                size: "48"
                                              }),
                                              (_ctx.canEdit)
                                                ? (_openBlock(), _createBlock("p", _hoisted_29, "No Image Selected"))
                                                : (_openBlock(), _createBlock("p", _hoisted_30, "No Image Uploaded")),
                                              (_ctx.canEdit)
                                                ? (_openBlock(), _createBlock("div", _hoisted_31, "Select an image"))
                                                : _createCommentVNode("", true)
                                            ]))
                                      ])
                                    ]))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    (_ctx.appState.admin)
                      ? (_openBlock(), _createBlock("div", _hoisted_32, [
                          _createVNode("div", {
                            id: 'PD-' + _ctx.pageState.job.ID,
                            class: "data-table card no-margin"
                          }, [
                            _createVNode(_component_f7_block_title, null, {
                              default: _withId(() => [
                                _hoisted_33
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_f7_list, { style: {"display":"flex","justify-content":"space-between","padding":"1rem"} }, {
                              default: _withId(() => [
                                _createVNode("div", null, _toDisplayString('Sets: ' + _ctx.pageState.job.program.sets), 1),
                                _createVNode("div", null, _toDisplayString('Total Runtime: ' + _ctx.pageState.job.totalProgramDuration()), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode("table", null, [
                              _hoisted_34,
                              _createVNode("tbody", null, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageState.job.program.zones, (z, i) => {
                                  return (_openBlock(), _createBlock("tr", {
                                    key: 'zone-' + i
                                  }, [
                                    (_ctx.pageState.job.program.singlePump && i == _ctx.pageState.job.program.zones.length - 1)
                                      ? (_openBlock(), _createBlock("td", _hoisted_35, "Hydro-Trough Zone"))
                                      : (_openBlock(), _createBlock("td", _hoisted_36, "Zone " + _toDisplayString(i + 1), 1)),
                                    _createVNode("td", _hoisted_37, _toDisplayString(_ctx.getPorts(i + 1)), 1),
                                    _createVNode("td", _hoisted_38, _toDisplayString(z.cycles), 1),
                                    _createVNode("td", _hoisted_39, _toDisplayString(_ctx.maskDuration(z.duration)), 1),
                                    _createVNode("td", _hoisted_40, _toDisplayString(_ctx.maskDuration(z.cycles * z.duration)), 1)
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _hoisted_41,
                            _createVNode(_component_import_program, {
                              program: _ctx.pageState.job.program,
                              onImport: _ctx.importProgram
                            }, null, 8, ["program", "onImport"])
                          ], 8, ["id"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_f7_block_title, null, {
                      default: _withId(() => [
                        _hoisted_42
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_file_upload, {
                      job: _ctx.pageState.job,
                      dir: "/designer",
                      readonly: !_ctx.appState.admin,
                      onFilesLength: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filesLengthChange($event)))
                    }, null, 8, ["job", "readonly"])
                  ])),
              (_ctx.showBOM)
                ? (_openBlock(), _createBlock("div", {
                    key: 2,
                    id: 'bom-' + _ctx.pageState.job.ID,
                    style: {"margin-bottom":"20px"}
                  }, [
                    _createVNode(_component_f7_block_title, null, {
                      default: _withId(() => [
                        _hoisted_43
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_bill_of_materials, {
                      "filter-by-package-type": true,
                      items: _ctx.pageState.job.bom,
                      readonly: _ctx.pageState.job.state != 'finalized',
                      "show-price": _ctx.appState.admin || (_ctx.appState.builderData?.paysThroughPortal ?? false),
                      "nozzle-color": _ctx.pageState.job.engineeringForm.color,
                      "onUpdate:nozzle-color": _cache[6] || (_cache[6] = ($event: any) => (_ctx.pageState.job.engineeringForm.color = $event))
                    }, null, 8, ["items", "readonly", "show-price", "nozzle-color"]),
                    _createVNode("input", {
                      style: {"display":"none"},
                      type: "file",
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.importBOM($event))),
                      id: "bom-input",
                      accept: ".csv"
                    }, null, 32),
                    _createVNode("label", _hoisted_44, [
                      (_ctx.appState.admin)
                        ? (_openBlock(), _createBlock(_component_f7_button, {
                            key: 0,
                            outline: "",
                            style: {"margin-top":"20px"},
                            href: false,
                            external: true,
                            text: "Import from csv"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.pageState.job.state === 'finalized' && !(_ctx.appState.builderData?.paysThroughPortal ?? true))
                      ? (_openBlock(), _createBlock("div", _hoisted_45, [
                          _createVNode(_component_f7_icon, {
                            f7: "cart_fill",
                            size: "28px",
                            style: {"margin-right":"12px","flex-shrink":"0"}
                          }),
                          _createVNode("div", _hoisted_46, [
                            _hoisted_47,
                            _createVNode("p", _hoisted_48, [
                              (_ctx.appState.builderData?.purchaseType === 'distribution')
                                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                    _hoisted_49
                                  ], 64))
                                : (_ctx.appState.builderData?.buyingGroupName === 'uag')
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                      _hoisted_50
                                    ], 64))
                                  : (_ctx.appState.builderData?.buyingGroupName === 'carecraft')
                                    ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                        _hoisted_51
                                      ], 64))
                                    : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, ["id"]))
                : _createCommentVNode("", true),
              _hoisted_52
            ])
          ])),
      _createVNode(_component_f7_fab, {
        class: "mobile-only",
        position: "right-bottom"
      }, {
        default: _withId(() => [
          _createVNode(_component_f7_icon, { f7: "chevron_right" }),
          _createVNode(_component_f7_icon, { f7: "xmark" }),
          _createVNode(_component_f7_fab_buttons, { position: "top" }, {
            default: _withId(() => [
              (_ctx.canEdit || _ctx.pageState.job.state === 'finalized')
                ? (_openBlock(), _createBlock(_component_f7_fab_button, {
                    key: 0,
                    onClick: _ctx.save,
                    label: _ctx.saveButtonText
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_f7_icon, { f7: "floppy_disk" })
                    ]),
                    _: 1
                  }, 8, ["onClick", "label"]))
                : _createCommentVNode("", true),
              (_ctx.pageState.job.state == 'staging')
                ? (_openBlock(), _createBlock(_component_f7_fab_button, {
                    key: 1,
                    "fab-close": "",
                    onClick: _ctx.finalize,
                    label: "Finalize"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_f7_icon, { f7: "arrow_uturn_up" })
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.pageState.job.state == 'finalized')
                ? (_openBlock(), _createBlock(_component_f7_fab_button, {
                    key: 2,
                    "fab-close": "",
                    onClick: _ctx.purchase,
                    label: "Submit Purchase Request",
                    color: "green"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_f7_icon, { f7: "cart" })
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.pageState.job.state == 'draft')
                ? (_openBlock(), _createBlock(_component_f7_fab_button, {
                    key: 3,
                    "fab-close": "",
                    onClick: _ctx.submit,
                    label: "Submit for Review"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_f7_icon, { f7: "arrow_uturn_up" })
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})